var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "title" }, [_vm._v("修改采购单")]),
      _c("div", { staticClass: "codeInfo" }, [
        _c("div", [
          _vm._v(" 采购编号："),
          _c("span", { staticStyle: { color: "#436ae8" } }, [
            _vm._v(_vm._s(_vm.leftContent.purchaseOrderNo)),
          ]),
        ]),
        _c("div", [_vm._v("制单人：" + _vm._s(_vm.leftContent.createdName))]),
        _c("div", [
          _vm._v(
            "制单时间：" + _vm._s(_vm.$moment(_vm.leftContent.createdTime))
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "leftContext" },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.leftContent.itemVOs } },
            [
              _c("el-table-column", {
                attrs: { label: "序号", type: "index", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { label: "供应商" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.supplierName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "创建人" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.createdName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "采购部门" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.purchaseOrgName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "采购仓库" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          _vm._l(scope.row.depotVos, function (items) {
                            return _c(
                              "p",
                              {
                                key: items.id,
                                staticStyle: { display: "inline-block" },
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(items.purchaseDepotName)),
                                ]),
                                scope.row.depotVos.length > 1
                                  ? _c("span", [_vm._v(",")])
                                  : _vm._e(),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "采购商品",
                  "show-overflow-tooltip": "",
                  "min-width": "120px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.purchaseProdName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商品类型" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.purchaseProdType == 1
                          ? _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openDetails(scope.row)
                                  },
                                },
                              },
                              [_vm._v("商品")]
                            )
                          : _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openDetails(scope.row)
                                  },
                                },
                              },
                              [_vm._v("赠品")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商品图片" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.purchaseProdImage
                          ? _c("img", {
                              staticStyle: { width: "50px", height: "50px" },
                              attrs: {
                                src: _vm.ImgHttps + scope.row.purchaseProdImage,
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openDetails(scope.row)
                                },
                              },
                            })
                          : _c("span", [_vm._v("/")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "品牌" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.purchaseProdBrandName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "规格" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(scope.row.purchaseProdSpecificationName)
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "采购金额" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.purchaseProdPrice))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "right" }, [
      _c("div", { staticClass: "title" }, [_vm._v("操作")]),
      _c(
        "div",
        { staticClass: "rightContext", staticStyle: { border: "0" } },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, "label-width": "80px" } },
            [
              _c("el-form-item", { attrs: { label: "采购部门" } }, [
                _c(
                  "div",
                  { staticClass: "selectTree" },
                  [
                    _c("treeselect", {
                      attrs: {
                        options: _vm.options,
                        "search-nested": "",
                        normalizer: _vm.normalizer,
                        noResultsText: "未找到",
                        placeholder: "请选择",
                        disabled: _vm.jage == 1 ? false : true,
                      },
                      model: {
                        value: _vm.form.bumenCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "bumenCode", $$v)
                        },
                        expression: "form.bumenCode",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "供应商" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "请输入供应商名称",
                      value: _vm.form.supplierName,
                      supplierName: "",
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "采购类型" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "请输入采购类型",
                      value: _vm.form.purchaseProdType == 1 ? "商品" : "赠品",
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "采购商品" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "请输入采购商品",
                      value: _vm.form.purchaseProdName,
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "采购规格" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "请输入采购规格",
                      value: _vm.form.purchaseProdSpecificationName,
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "采购品牌" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "请输入采购品牌",
                      value: _vm.form.purchaseProdBrandName,
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "采购金额" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "请输入采购金额",
                      value: Number(
                        _vm.form.purchaseProdPrice *
                          _vm.form.purchaseProdQuantity
                      ).toFixed(2),
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "采购数量" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "number",
                      size: "small",
                      placeholder: "请输入采购数量",
                      value: _vm.form.purchaseProdQuantity,
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "入库仓库" } },
                [
                  _vm._l(_vm.form.depotVos1, function (ite, index) {
                    return ite.type == 0 || ite.type == undefined
                      ? _c(
                          "div",
                          {
                            key: index,
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                              "align-items": "center",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  value: ite.purchaseDepotName,
                                  size: "mini",
                                  "value-key": "purchaseDepotId",
                                  placeholder: "请选择",
                                  disabled: _vm.jage == 1 ? false : true,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.myWareListChange($event, ite)
                                  },
                                },
                              },
                              _vm._l(_vm.wareList.list, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item },
                                })
                              }),
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                },
                              },
                              [
                                _c("el-input-number", {
                                  staticStyle: { "margin-right": "10px" },
                                  attrs: {
                                    size: "mini",
                                    min: 0,
                                    placeholder: "请输入库存数量",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.inputChange(ite)
                                    },
                                  },
                                  model: {
                                    value: ite.purchaseProdQuantity,
                                    callback: function ($$v) {
                                      _vm.$set(ite, "purchaseProdQuantity", $$v)
                                    },
                                    expression: "ite.purchaseProdQuantity",
                                  },
                                }),
                                _vm.jage == 1
                                  ? _c("i", {
                                      staticClass: "el-icon-remove-outline",
                                      staticStyle: { cursor: "pointer" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteMyWare(
                                            ite,
                                            ite.type != undefined ? 1 : 0
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  _vm.jage == 1
                    ? _c("i", {
                        staticClass: "el-icon-circle-plus-outline",
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.addMyWareList(_vm.form)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "el-form-item",
                { attrs: { label: "上传图片" } },
                [
                  _vm.jage == 1
                    ? _c(
                        "el-upload",
                        {
                          ref: "upload",
                          staticClass: "video",
                          attrs: {
                            action: "#",
                            "file-list": _vm.form.fileListImg,
                            multiple: "",
                            "before-upload": _vm.beforeUploadImg,
                            "http-request": _vm.imgUpload,
                            "show-file-list": false,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { type: "primary", size: "mini" } },
                            [_vm._v("选择图片")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._l(_vm.form.fileListImg, function (itemsImg, index) {
                    return _vm.form.fileListImg
                      ? _c("div", { key: index, staticClass: "liimg" }, [
                          itemsImg
                            ? _c("img", {
                                directives: [
                                  {
                                    name: "image-preview",
                                    rawName: "v-image-preview",
                                  },
                                ],
                                staticClass: "img-avatar",
                                attrs: { src: _vm.ImgHttps + itemsImg.img },
                              })
                            : _vm._e(),
                          itemsImg && _vm.jage == 1
                            ? _c(
                                "p",
                                {
                                  staticClass: "close",
                                  on: {
                                    click: function ($event) {
                                      return _vm.delectImgList(index)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-error" })]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e()
                  }),
                ],
                2
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "255",
                      placeholder: "请输入备注",
                      type: "textarea",
                    },
                    model: {
                      value: _vm.textarea,
                      callback: function ($$v) {
                        _vm.textarea = $$v
                      },
                      expression: "textarea",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "p",
            { staticStyle: { "text-align": "right", "margin-top": "50px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.submit },
                },
                [_vm._v("提交")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }